import { LitEntity, SirenActionMixin, renderIf, css, html } from '../../utility/lit-entity';
import { sharedStyles } from '../../styles/shared-styles';
import '../../common/bn-surface';
import '../../common/bn-icon';
import '../props/bin-name';
import '../props/bin-owner';

class DeviceRemovalSummary extends SirenActionMixin(LitEntity) {
  static get styles() {
    return [sharedStyles, css`
      .card-contents {
        display: flex;
      }
      .device-details {
        flex-grow: 1;
      }
    `];
  }

  render() {
    if (!this.entity) {
      return html``;
    }

    const hasUpdate = this.entity.hasActionByName('update-bin');

    return html`
      <bn-surface>
        <div class="card-contents">
          <div class="device-details">
            <div class="group">
              <label>Serial:</label>
              <span class="value">${this.entity.properties.deviceId}</span>
            </div>
            <div class="group">
              <label>Version:</label>
              <span class="value">${this.entity.properties.version}</span>
            </div>
          </div>

          ${renderIf(hasUpdate, html`
            <button
              class="button button--containedError"
              @click="${this._onClickRemoveDevice}"
            >
              <bn-icon name="fal fa-times"></bn-icon> Remove Device From Bin
            </button>
          `)}
        </div>
      </bn-surface>
    `;
  }

  async _onClickRemoveDevice(e) {
    e.stopPropagation();
    e.preventDefault();

    if (!confirm('Are you sure you want to remove this device from its bin?')) {
      return;
    }

    const action = this.entity.getActionByName('update-bin');
    if (!action) {
      return;
    }

    try {
      this.loading = true;
      const fields = this.getActionFields(action);
      fields.set('binId', '');
      const { entity, error } = await this.submitAction(action, fields);
      this.loading = false;
      if (error) {
        this.dispatchEvent(new ErrorEvent('error', { error }));
      } else {
        this.dispatchEvent(new ErrorEvent('deviceremoved', { entity, bubbles: true, composed: true }));
      }
    } catch (err) {
      this.dispatchEvent(new ErrorEvent('error', { error: err }));
      this.loading = false;
    }
  }
}

window.customElements.define('device-removal-summary', DeviceRemovalSummary);
